module.exports = __webpack_public_path__ + "static/neon-home-c119ac447c86be8555d2e3bcd30cf40e.webm";